import { createServerFn } from "@tanstack/react-start"
import { Result } from "@praha/byethrow"
import { getCurrentUser as getCurrentUserService } from "@apps/gwservice/auth"
import { getUnreadCount as getUnreadCountService } from "@apps/gwservice/notifications"
import { withAuth } from "../../auth/server/auth"

export const getCurrentUser = createServerFn({
  method: "GET",
})
  .handler(() =>
    Result.try({
      try: () => withAuth(getCurrentUserService)(),
      catch: () => "unexpected server error",
    }),
  )

export const getUnreadCount = createServerFn({
  method: "GET",
})
  .handler(() =>
    Result.try({
      try: () => withAuth(getUnreadCountService)(),
      catch: () => "unexpected server error",
    }),
  )
